module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=FK - Falkland Islands.67541004.svg";